export default {
    add_all_materials_from_warehouse: "Додати всі матеріали зі складу",
    add_good: "Додати товар",
    add_material: "Додати матеріал",
    add_new: "Додати новий",
    adding_new_supplier: "Додавання нового постачальника",
    addition: "Прихід",
    address: "Адреса",
    adjustment: "Коригування",
    amount: "Кіл-ть",
    amount_of_stock_on_all_warehouses: "Загальна кількість товару, доступна на всіх складах клініки",
    approve: "Провести",
    approved: "Проведено",
    are_you_sure_you_want_to_delete_group: "Ви впевнені, що хочете видалити групу?",
    are_you_sure_you_want_to_delete_kit: "Ви впевнені, що хочете видалити комплект?",
    are_you_sure_you_want_to_delete_supplier: "Ви впевнені, що хочете видалити постачальника?",
    are_you_sure_you_want_to_delete_warehouse: "Ви впевнені, що хочете видалити склад?",
    artikul: "Артикул",
    available_for_sale: "В наявності для продажу",
    bank_requisites: "Банківські реквізити",
    barcode: "Штрихкод",
    beginning_balance: "Початковий залишок",
    bin: "БІН",
    branch: "Філія",
    bulk_addition: "Додати групою",
    by_categories: "За категоріями",
    consumption: "Витрата",
    consumption_manual: "Ручна витрата",
    contact_person: "Контактна особа",
    contragent: "Контрагент",
    cost: "Вартість",
    created: "Створено",
    current_stock: "Поточний залишок",
    default_for_sale: "Використовувати за умовчанням для продажу продуктів",
    default_for_writeoff: "Використовувати за умовчанням для списання матеріалу",
    destination: "Призначення",
    details: "Деталі",
    difference: "Розбіжність",
    documents: "Документи",
    draft: "Чернетка",
    enter_title_or_barcode: "Уведіть наименування або штрихкод",
    factual_amount: "Кількість за фактом",
    finished: "Проведено",
    finished2: "Завершено",
    found_similar_material: "Знайдено схожий матеріал",
    from: "від",
    from_warehouse: "Переміщення зі складу",
    from_where: "Звідки",
    general_price: "Загальна сума",
    general_stock: "Загальний залишок",
    group: "Група",
    groups: "Групи",
    id: "Id",
    in_warehouse: "На складі",
    inventarization: "Інвентаризація",
    kit: "Комплект",
    Kit: "Комплект",
    kits: "Комплекти",
    material: "Матеріал",
    materialgroup: "Група",
    materials: "Матеріали",
    materialstock: "Матеріал",
    movement: "Переміщення",
    movement_from: "Переміщення",
    movement_to: "Переміщення",
    movements: "Рухи",
    nomenclature: "Номенклатура",
    not_enough_material: "Недостатньо матеріалу",
    notify_when_stock: "Повідомляти при залишку",
    on_visit_close: "При закритті візиту",
    on_visit_save: "При збереженні візиту",
    operation: "Операція",
    parent_category: "Батьківська категорія",
    parent_group: "Батьківська група",
    physical: "Фізичний",
    price_will_be_used_automatically_from_addition: "Ціна буде застосована автоматично з документа приходу",
    print: "Роздрукувати",
    prohibit_minus_stocks: "Заборонити списувати в мінус матеріали",
    prohibit_minus_stocks_in_warehouse_documents: "Ця установка забороняє списувати матеріали в мінус під час заповнення документів у розділі 'Склад'",
    prohibit_minus_stocks_on_visit_closing: "Заборонити списання матеріалів візиту в мінус (заборона на завершення візиту)",
    purchase_price: "Закупівельна ціна",
    return: "Повернення",
    returns: "Повернення",
    sale_of_goods_refund: "Повернення продажу товарів",
    sale_price: "Ціна продажу",
    stocks: "Залишки",
    stocks_archive: "Архів матеріалів",
    supplier: "Постачальник",
    suppliers: "Постачальники",
    to_warehouse: "Переміщення на склад",
    to_where: "Куди",
    trying_to_writeoff: "Спроба списати",
    type: "Тип",
    unit_of_measure: "Од./вим.",
    virtual: "Віртуальний",
    warehouse_amount: "Кількість на складі",
    warehouseoperation: "Операції",
    warehouses: "Склади",
    write_off: "Списання",
    write_off_materials: "Списати матеріали"
}
